import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import { ExerciseStatus } from '../../../constants/exercises'
import NtfGame from './NtfGame'
import NtfLevelGenderChooser from './NtfLevelGenderChooser'
import NtfCardsReview from './NtfCardsReview'
import { Gender } from '../ntfHelper'
import { Card, NtfExercises } from '../ntfSlice'

export interface INtfInProgressProps {
  status: ExerciseStatus
  exercises?: NtfExercises
  currentExercise: number
  cards?: Card[]
  selectedLevel?: number
  pickLevelAndGender: (level: number, gender: Gender | undefined) => void
  finishExercise: (attempts: number) => void
}

const NtfInProgress = ({
  currentExercise,
  exercises,
  finishExercise,
  pickLevelAndGender,
  selectedLevel,
  status,
  cards,
}: INtfInProgressProps) => {
  const [reviewedCards, setReviewedCards] = useState<boolean>(false)

  if (status !== 'in-progress' || exercises === undefined) { return null }

  const hasLoadedCards = cards && cards.length > 0

  const loadingCards = cards && cards.length === 0

  const handleDoneReview = () => {
    setReviewedCards(true)
  }

  const handleFinishExercise = (attempts: number) => {
    setReviewedCards(false)
    finishExercise(attempts)
  }

  return (
    <>
      {
        hasLoadedCards && <Container>
          <h4>Exercise {currentExercise}</h4>      
        </Container>
      }
      <NtfLevelGenderChooser 
        hidden={hasLoadedCards}
        loadingCards={loadingCards}
        levels={exercises.levels}
        minLevelGenderSelection={exercises.minLevelGenderSelection}
        pickLevelAndGender={pickLevelAndGender} 
      />
      <NtfCardsReview
        hidden={reviewedCards}
        level={selectedLevel}
        cards={hasLoadedCards ? cards: undefined}
        doneReview={handleDoneReview}
      />
      <NtfGame 
        cardBack={exercises.cardBack}
        level={selectedLevel}
        cards={hasLoadedCards && reviewedCards ? cards : undefined}
        gameCompleted={handleFinishExercise}
      />
    </>
  )
}

export default NtfInProgress